import { Component, OnInit, AfterViewInit, Input  } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";

@Component({
  selector: 'intelligent-transfer',
  templateUrl: './intelligent-transfer.component.html',
  styleUrls: []
})
export class IntelligentTransferComponent implements OnInit, AfterViewInit {
  token : string= "";
  isShowLoadingComponent: boolean = true;
  constructor(private route: ActivatedRoute,
              private router: Router,
              private apiService: ApiService,
              private commonService: CommonService) {}

  ngOnInit() {
    //先判断是否有token
    this.token = localStorage.getItem("transtalen-token")? localStorage.getItem("transtalen-token") : '';
    this.checkIntelligent();
  };


  ngAfterViewInit() {

  }

  checkIntelligent(){
    this.route.queryParams.subscribe(params => {
        let projectId = params['projectid'];
        let courseId = params['courseId'];
        let device = params['device'];
        let exerciseIds = params['exerciseIds'];
        this.intelligentApi(projectId,courseId).then(res=>{
            if(res.success){
              let mobProjectUrl = window.location.origin + '/learning-project/'+ projectId;//mob项目列表
              let IntelligentUrl = window.location.origin + '/ai/aicoach/list/'+ courseId + '?device=' + device + '&projectId=' + projectId + '&exerciseIds=' + exerciseIds +'&back_url=' + encodeURIComponent(mobProjectUrl) + '&transtalent_token=' + this.token;
              window.location.href = IntelligentUrl;
            }else if(res.data.code === 101 || res.data.code === 102){//101:项目未发布 102:该学员不在当前项目中
                this.router.navigate(['learning-map'],{queryParams:{code:res.data.code}});
            }else if(res.data.code === 103){//该课程还未解锁
                this.router.navigate(['learning-project', projectId]);
            }
        }).then(()=>{
          this.isShowLoadingComponent = false;
        })
    });

  }



  //智能陪练短链登录校验
  intelligentApi(projectId,courseId){
    return this.apiService.ajax({
      'type': 'GET',
      'url': `ddilearner/v3/project/validateAirpLink?projectId=${projectId}&courseId=${courseId}`,
    }).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/app/intelligent-transfer/intelligent-transfer.component.ts